var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckout = function SvgIconCheckout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.042 17.396a.52.52 0 0 0-1.042 0v1.562h-1.562a.52.52 0 0 0 0 1.042H20v1.563a.521.521 0 0 0 1.042 0V20h1.562a.52.52 0 0 0 0-1.042h-1.562z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.188 12.708a.52.52 0 0 0 0 1.042h1.156l.418 1.674 1.56 8.318a.52.52 0 0 0 .511.425h1.042a2.083 2.083 0 1 0 0 4.166 2.083 2.083 0 0 0 0-4.166h7.292a2.083 2.083 0 1 0 0 4.166 2.083 2.083 0 0 0 0-4.166h1.041a.52.52 0 0 0 .512-.425l1.562-8.334a.52.52 0 0 0-.511-.616H14.677l-.422-1.689a.52.52 0 0 0-.505-.395zm4.078 10.417-1.368-7.292h11.246l-1.368 7.292zm1.65 3.125a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.084 0m7.292 0a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 19.5
  })));
};
export default SvgIconCheckout;